/**
 * Presets de skeleton específicos do Portal — injetados no plugin do DS.
 */
export const DOMAIN_SKELETON_PRESETS = Object.freeze({
    'hospedagem-detail': {
        showResumo: true,
        resumoCount: 5,
        tabWidths: ['3.25rem', '6rem', '5rem', '3rem', '3.25rem'],
        sections: [
            {
                fields: [
                    { key: 'evento', span: 12 },
                    { key: 'gestor', span: 6 },
                    { key: 'unidade', span: 6 },
                    { key: 'checkin', span: 4 },
                    { key: 'checkout', span: 4 },
                    { key: 'cidade', span: 4 },
                    { key: 'observacao', span: 12, tall: true },
                ],
            },
        ],
        actionLayout: 'detail-bar',
        actionButtonsEnd: 3,
    },
    'tramitacao-detail': {
        showResumo: true,
        resumoCount: 4,
        tabWidths: ['4.5rem', '3rem'],
        sections: [
            {
                fields: [
                    { key: 'numero', span: 4 },
                    { key: 'data', span: 4 },
                    { key: 'solicitante', span: 4 },
                    { key: 'ata', span: 4 },
                    { key: 'assunto', span: 8 },
                    { key: 'objeto', span: 12, tall: true },
                    { key: 'gestor', span: 6 },
                    { key: 'unidade-gestor', span: 6 },
                ],
            },
        ],
        actionLayout: 'detail-bar',
        actionButtonsEnd: 3,
    },
    'parceria-detail': {
        showResumo: true,
        resumoCount: 5,
        tabWidths: ['4rem', '4rem', '5rem', '4.5rem', '3.5rem', '3.5rem', '3rem', '3rem', '3rem', '3rem', '3rem'],
        sections: [
            {
                fields: [
                    { key: 'numero-acordo', span: 4 },
                    { key: 'status', span: 4 },
                    { key: 'parceiro', span: 4 },
                    { key: 'vigencia', span: 6 },
                    { key: 'gerente', span: 6 },
                ],
            },
        ],
        actionLayout: 'detail-bar',
        actionButtonsEnd: 2,
    },
});
